<div class="collection-container">
  <div class="collection-header">
    <hyperkit-typography variant="label1" align="left" color="inactive"
      >Collection</hyperkit-typography
    >
    <hyperkit-typography variant="h5" align="left" color="primary">{{
      data.collection.title
    }}</hyperkit-typography>

    <div class="collection-meta">
      <div class="date">
        <hyperkit-badge variant="neutral" text="Created"></hyperkit-badge>
        <hyperkit-typography variant="label1" align="left" color="primary">{{
          data.collection.created_date | date: 'longDate'
        }}</hyperkit-typography>
      </div>
      <div class="date">
        <hyperkit-badge variant="neutral" text="Updated"></hyperkit-badge>
        <hyperkit-typography variant="label1" align="left" color="primary">{{
          data.collection.last_updated | date: 'longDate'
        }}</hyperkit-typography>
      </div>
    </div>

    <div class="options">
      <span *ngIf="huntCompatible">
        <span *ngIf="huntModuleAccess; else noAccess">
          <kendo-dropdownbutton
            class="hunt-button"
            themeColor="primary"
            [data]="options"
            textField="actionName"
            icon="chevron-down"
          >
            Hunt
          </kendo-dropdownbutton>
        </span>
      </span>
      <ng-template #noAccess>
        <cyborg-button color="outline" size="small" (click)="openHuntDialog()">
          <img
            class="icon-premium"
            width="16"
            height="16"
            src="/assets/img/icons/cyborg-premium.png"
          />
          Hunt
        </cyborg-button>
      </ng-template>
    </div>
  </div>

  <cyborg-section class="main-section">
    <div class="collection-content">
      <div class="content-panel">
        <div class="threat-summary">
          <collection-header>
            <cyborg-markdown
              [md]="data.collection.threat_summary"
            ></cyborg-markdown>
          </collection-header>
        </div>
      </div>

      <div class="tabs-panel">
        <!-- <hyperkit-tab-bar
          class="collections-tabs"
          variant="secondary"
          mode="underline"
        > -->
        <!-- <hyperkit-tab
            text="Hunt Packages"
            *ngIf="data.huntPackages && data.huntPackages.length != 0"
            [selected]="true"
          >
            <div
              *ngFor="let huntPackage of data.huntPackages"
              class="hp-list"
            >
              <div class="header">
                <cyborg-trial-lock-unlock [huntPackage]="huntPackage"></cyborg-trial-lock-unlock>
                <hyperkit-badge
                  [variant]="mapSeverityToBadgeVariant(huntPackage.severity)"
                  indicator="dot"
                  size="large"
                  [text]="huntPackage.severity">
                </hyperkit-badge>
              </div>
              <div class="hunt-package-meta">
                <div class="date">
                  <hyperkit-badge variant="neutral" text="Created"></hyperkit-badge>
                  <hyperkit-typography variant="label1" align="left" color="primary">{{ huntPackage.created_date | date : 'longDate' }}</hyperkit-typography>
                </div>
                <div class="date">
                  <hyperkit-badge variant="neutral" text="Updated"></hyperkit-badge>
                  <hyperkit-typography variant="label1" align="left" color="primary">{{ huntPackage.last_updated | date : 'longDate' }}</hyperkit-typography>
                </div>
              </div>
              <div class="hunt-package-meta">
                <div *ngIf="huntPackage.dependencies.length != 0" class="deps">
                  <hyperkit-badge variant="neutral" text="Dependencies"></hyperkit-badge>
                  <hyperkit-typography variant="label1" align="left" color="primary">{{ huntPackage?.dependencies.join(', ') }}</hyperkit-typography>
                </div>
              </div>
              <hyperkit-typography variant="body1" align="left" color="body">{{ huntPackage.description }}</hyperkit-typography>
            </div>            
          </hyperkit-tab>
          <hyperkit-tab text="Recently Updated">
            <p>2</p>
          </hyperkit-tab>
          <hyperkit-tab text="My Environment">
            <p>3</p>
          </hyperkit-tab>
          <hyperkit-tab text="MITRE">
            <p>4</p>
          </hyperkit-tab>
        </hyperkit-tab-bar> -->
        <hyperkit-tab-bar
          class="collections-tabs"
          variant="secondary"
          mode="underline"
        >
          <hyperkit-tab
            *ngIf="data.huntPackages && data.huntPackages.length != 0"
            text="Hunt Packages"
            [selected]="true"
          >
            <div *ngFor="let huntPackage of data.huntPackages" class="hp-list">
              <div class="header">
                <cyborg-trial-lock-unlock
                  [huntPackage]="huntPackage"
                ></cyborg-trial-lock-unlock>
                <hyperkit-badge
                  [variant]="mapSeverityToBadgeVariant(huntPackage.severity)"
                  indicator="dot"
                  size="large"
                  [text]="huntPackage.severity"
                >
                </hyperkit-badge>
              </div>
              <div class="hunt-package-meta">
                <div class="date">
                  <hyperkit-badge
                    variant="neutral"
                    text="Created"
                  ></hyperkit-badge>
                  <hyperkit-typography
                    variant="label1"
                    align="left"
                    color="primary"
                    >{{
                      huntPackage.created_date | date: 'longDate'
                    }}</hyperkit-typography
                  >
                </div>
                <div class="date">
                  <hyperkit-badge
                    variant="neutral"
                    text="Updated"
                  ></hyperkit-badge>
                  <hyperkit-typography
                    variant="label1"
                    align="left"
                    color="primary"
                    >{{
                      huntPackage.last_updated | date: 'longDate'
                    }}</hyperkit-typography
                  >
                </div>
              </div>
              <div class="hunt-package-meta">
                <div *ngIf="huntPackage.dependencies.length != 0" class="deps">
                  <hyperkit-badge
                    variant="neutral"
                    text="Dependencies"
                  ></hyperkit-badge>
                  <hyperkit-typography
                    variant="label1"
                    align="left"
                    color="primary"
                    >{{
                      huntPackage?.dependencies.join(', ')
                    }}</hyperkit-typography
                  >
                </div>
              </div>
              <hyperkit-typography variant="body1" align="left" color="body">{{
                huntPackage.description
              }}</hyperkit-typography>
            </div>
          </hyperkit-tab>

          <hyperkit-tab text="Details">
            <div class="details-content">
              <cyborg-markdown
                [md]="data.collection.synopsis"
              ></cyborg-markdown>
            </div>
          </hyperkit-tab>

          <hyperkit-tab
            *ngIf="data.threatProfiles && data.threatProfiles.length != 0"
            text="Threat Profiles"
          >
            <div
              *ngFor="let threatProfile of data.threatProfiles"
              class="threat-profile-item"
            >
              <div class="header">
                <hyperkit-link
                  [routerLink]="[
                    '/research/threat-profile',
                    threatProfile.UUID,
                  ]"
                  variant="h5"
                  color="primary"
                  [text]="threatProfile.profile_name"
                >
                </hyperkit-link>
                <hyperkit-badge
                  [variant]="mapSeverityToBadgeVariant(threatProfile.impact[0])"
                  indicator="dot"
                  size="large"
                  [text]="threatProfile.impact[0]"
                >
                </hyperkit-badge>
              </div>
              <div class="hunt-package-meta">
                <div
                  *ngIf="
                    threatProfile.also_known_as &&
                    threatProfile.also_known_as.length != 0
                  "
                  class="date"
                >
                  <hyperkit-badge
                    variant="neutral"
                    text="Also Known As"
                  ></hyperkit-badge>
                  <hyperkit-typography
                    variant="label1"
                    align="left"
                    color="primary"
                    >{{
                      threatProfile.also_known_as.join(', ')
                    }}</hyperkit-typography
                  >
                </div>
                <div
                  *ngIf="
                    threatProfile.context.motivations &&
                    threatProfile.context.motivations.length != 0
                  "
                  class="date"
                >
                  <hyperkit-badge
                    variant="neutral"
                    text="Motivations"
                  ></hyperkit-badge>
                  <hyperkit-typography
                    variant="label1"
                    align="left"
                    color="primary"
                    >{{
                      threatProfile.context.motivations.join(', ')
                    }}</hyperkit-typography
                  >
                </div>
              </div>
              <div class="hunt-package-meta">
                <div
                  *ngIf="
                    threatProfile.targeting && threatProfile.targeting != ''
                  "
                  class="deps"
                >
                  <hyperkit-badge
                    variant="neutral"
                    text="Targeting"
                  ></hyperkit-badge>
                  <hyperkit-typography
                    variant="label1"
                    align="left"
                    color="primary"
                    >{{ threatProfile?.targeting }}</hyperkit-typography
                  >
                </div>
              </div>
              <hyperkit-typography variant="body1" align="left" color="body">{{
                threatProfile.overview
              }}</hyperkit-typography>
            </div>
          </hyperkit-tab>
        </hyperkit-tab-bar>
      </div>
    </div>
  </cyborg-section>

  <cyborg-section class="tags-section">
    <cyborg-content-section>
      <div class="tags-container">
        <collection-header>
          <cyborg-facet-buttons
            class="tile-facets"
            [facets]="tags"
            [groupByCategory]="true"
          ></cyborg-facet-buttons>
        </collection-header>
      </div>
    </cyborg-content-section>
  </cyborg-section>
</div>
